import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { MingaSettingsService } from '@app/src/app/store/Minga/services';

@Injectable()
export class CanAccessPointsGuard {
  constructor(private _settingsService: MingaSettingsService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._settingsService.isPbisModuleEnabled();
  }
}
